import gql from 'graphql-tag'

import { AddressFieldsFragment } from 'main/gql/address'
import { ProfileFieldsFragment } from 'main/gql/profile'

export const ExternalSchoolFieldsFragment = gql`
  fragment ExternalSchoolFields on ExternalSchool {
    id
    slug
    claimPath
    name
    directorAvatarUrl
    directorFirstName
    directorLastName
    directorPhone
    directorEmail
    headerImageUrl
    licenseNumber
    licenseProofUrl
    locationDescription
    philosophyDescription
    programType
    teacherDescription
    address {
      ...AddressFields
    }
    profile {
      ...ProfileFields
    }
  }

  ${AddressFieldsFragment}
  ${ProfileFieldsFragment}
`
